import useSWR from 'swr';
import { useMemo } from 'react';

import { httpGet } from 'src/utils/cms-axios';
import { saveAdminConfig } from './admin-config-save';

export async function getPostAdminConfig(site_id, post_type_id) {
    const res = await httpGet("/post-admin-config", {
        "post_type_id": post_type_id,
    }, { "cms-site-id": site_id }, "/config-api");
    if (res && res.settings && res.settings.edit) {
        Object.keys(res.settings.edit).forEach((k) => {
            const item = res.settings.edit[k];
            if (typeof item.field === 'string') {
                try { item.field = JSON.parse(item.field); } catch (e) { item.field = {}; }
            }
            if (typeof item.validation === 'string') {
                try { item.validation = JSON.parse(item.validation); } catch (e) { item.validation = {}; }
            }
            if (typeof item.ai === 'string') {
                try { item.ai = JSON.parse(item.ai); } catch (e) { item.ai = {}; }
            }
            if (typeof item.options === 'string') {
                try { item.options = JSON.parse(item.options); } catch (e) { item.options = []; }
            }
            if (typeof item.labels === 'string') {
                try { item.labels = JSON.parse(item.labels); } catch (e) { item.labels = []; }
            }
        });
    }
    return res;
}

// base_version: 開いたときの保存版トークン（GET の version）。undefined なら照合しない
// （admin-config-save.js）。
export function updatePostAdminConfig(data) {
    const { site_id, post_type_id, settings, base_version } = data;
    return saveAdminConfig(
        `/post-admin-config?post_type_id=${post_type_id}`, settings, site_id, base_version);
}

export function useGetPostAdminConfig(site_id, post_type_id) {
    const { data, isLoading, isError, isValidating, mutate, error } = useSWR(
        site_id && post_type_id ? ['/config-api/post-admin-config', site_id, post_type_id] : null,
        () => getPostAdminConfig(site_id, post_type_id)
    );

    const memoizedValue = useMemo(
        () => ({
            configData: data || null,
            configLoading: isLoading,
            configError: error,
            configValidating: isValidating,
            configRefresh: mutate,
        }),
        [data, error, isLoading, isValidating, mutate]
    );

    return memoizedValue;
}
